import { Link, useLocation } from 'react-router-dom';

// Icônes en SVG inline (style Lucide/Feather) : aucune dépendance externe,
// elles héritent de la couleur du texte (currentColor).
const ICONS = {
  bell: (
    <>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </>
  ),
  key: (
    <>
      <path d="m21 2-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </>
  ),
  car: (
    <>
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
      <path d="M9 17h6" />
    </>
  ),
  trend: (
    <>
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </>
  ),
  cash: (
    <>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="2" />
      <path d="M6 12h.01M18 12h.01" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="10" r="3" />
      <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" />
    </>
  ),
};

const NAV_TABS = [
  { to: '/account/demandes', label: 'Demandes', icon: 'bell' },
  { to: '/account/locations', label: 'Locations', icon: 'key' },
  { to: '/account/voitures', label: 'Voitures', icon: 'car' },
  { to: '/account/performances', label: 'Perfs', icon: 'trend' },
  { to: '/business/earnings', label: 'Revenus', icon: 'cash' },
  { to: '/account/settings', label: 'Compte', icon: 'user' },
];

function NavIcon({ name }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {ICONS[name]}
    </svg>
  );
}

function Nav() {
  const { pathname } = useLocation();

  return (
    <nav
      className="mc-account-nav"
      aria-label="Navigation du compte"
      style={{ marginTop: '0.5rem' }}
    >
      <ul className="mc-account-nav-list">
        {NAV_TABS.map(({ to, label, icon }) => {
          const active =
            pathname.startsWith(to) ||
            (to === '/business/earnings' && pathname.includes('earnings'));
          return (
            <li key={to}>
              <Link
                to={to}
                className={`mc-account-nav-link${active ? ' is-active' : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                <NavIcon name={icon} />
                <span>{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Nav;
